// extracted by mini-css-extract-plugin
var _1 = "description__xjLGu";
var _2 = "no-wrap__Yz5ra";
export { _1 as "description", _2 as "noWrap" }
